import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./feed.css?inline";

@customElement("eko-feed")
class Feed extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) variant?: "dots" | "dividers";

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-feed": Feed;
  }
}

export default Feed;
